import PackagingMethodLevel from "../../shared/packaging/PackagingMethodLevel";
import { PackagingGate } from "../../shared/packaging/packagingLevel.types";

type PackagingMethodProps = {
  gate?: PackagingGate;
  processGateId: string;
  packagingData: any[];
  refetchData: (...args: any[]) => any;
  packagingId: string | null;
  savePackingNodeData: (id: string, name?: string) => void;
  packagingName?: string;
  onPackagingSave?: (packagingId: string) => void;
  lockStatus?: boolean;
};

const PackagingMethod = ({
  processGateId,
  gate = "process-gate",
  ...props
}: PackagingMethodProps) => {
  return <PackagingMethodLevel gate={gate} gateId={processGateId} {...props} />;
};

export default PackagingMethod;
